import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ButtonType extends BaseOption {
  static userInterfaceComponent = {
    label: "Variant",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      displayCaretIcon: true,
      options: [
        {
          id: "primary",
          name: "Primary",
        },
        {
          id: "secondary",
          name: "Secondary",
        },
        {
          id: "tertiary",
          name: "Tertiary",
        },
      ],
    },
  };

  static defaultValue = "primary";
}
